import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface HistorialExtraContractual {
  id?: number;
  placa: string;
  aseguradora: string;
  intermediaria: string;
  fecha_expedicion: string;
  fecha_vencimiento: string;
  numero: string;
  estado?: number;
}

@Injectable({
  providedIn: 'root',
})
export class HistorialExtraContractualService {
  private apiUrl =  `${environment.apiUrl}/api/historial_extracontractual`; 
  private apiUrl2 =  `${environment.apiUrl}/api/historial/renovar`; 
 // private apiUrl = 'http://localhost:3000/api/historial_extracontractual';
  //private apiUrl2 = 'http://localhost:3000/api/historial/renovar'; // Ajusta la URL si es necesario

  constructor(private http: HttpClient) {}

  // Obtener todos los historiales
  getAll(): Observable<{ historial: HistorialExtraContractual[] }> {
    return this.http.get<{ historial: HistorialExtraContractual[] }>(this.apiUrl);
  }
  
  // Obtener historial por ID
  getById(id: number): Observable<HistorialExtraContractual> {
    return this.http.get<HistorialExtraContractual>(`${this.apiUrl}/${id}`);
  }

  // Crear nuevo historial
  create(data: HistorialExtraContractual): Observable<HistorialExtraContractual> {
    return this.http.post<HistorialExtraContractual>(this.apiUrl, data);
  }

  // Actualizar historial por ID
  update(id: number, data: HistorialExtraContractual): Observable<HistorialExtraContractual> {
    return this.http.put<HistorialExtraContractual>(`${this.apiUrl}/${id}`, data);
  }

  // Eliminar historial por ID
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  inactivarPorId(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/inactivar/${id}`, {}); // {} cuerpo vacío
  }

  
  obtenerHistoriales(fechaExpedicionRCE: string, fechaVencimientoRCE: string): Observable<any> {
    const body = { fecha_expedicionRCE: fechaExpedicionRCE, fecha_vencimientoRCE: fechaVencimientoRCE };
    console.log('📤 Enviando a extracontractualService:', body);
    return this.http.post<any>(this.apiUrl2, body);
  }
}
  